import { IHAChangePollingPlace } from '../interfaces/IHAChangePollingPlace';
import { IHAStaticCandidate } from '../interfaces/IHAStaticCandidate';
import { IHAStaticPollingPlace } from '../interfaces/IHAStaticPollingPlace';
import { PollingCandidateCount } from './PollingCandidateCount';

export class PollingPlaceCount {

  private readonly _haStaticPollingPlace: IHAStaticPollingPlace;
  private readonly _haStaticCandidates: IHAStaticCandidate[];
  private readonly _haChangePollingPlace: IHAChangePollingPlace;

  public pollingCandidates: PollingCandidateCount[] = [];
  private totalFormalVotesValue = 0;

  constructor(
    haStaticPollingPlace: IHAStaticPollingPlace,
    haStaticCandidates: IHAStaticCandidate[],
    haChangePollingPlace: IHAChangePollingPlace
  ) {
    this._haStaticPollingPlace = haStaticPollingPlace;
    this._haStaticCandidates = haStaticCandidates;
    this._haChangePollingPlace = haChangePollingPlace;

    this._haChangePollingPlace.pollingCandidates.forEach(pollingCandidate => {
      const candidate = this._haStaticCandidates.find(x => x.candidateId === pollingCandidate.candidateId);
      if (candidate) {
        this.pollingCandidates.push(new PollingCandidateCount(
          pollingCandidate,
          candidate
        ));
      }
    });
  }

  public afterInit(): void {
    this.pollingCandidates.forEach(pollingCandidate => pollingCandidate.afterInit());

    // calc totals here
    this.totalFormalVotesValue = this._haChangePollingPlace.pollingCandidates.reduce((sum, current) => sum + current.formalVotes, 0);
  }


  public get totalFormalVotes(): number {
    return this.totalFormalVotesValue;
  }

  public get informalVotes(): number {
    return this._haChangePollingPlace.informalVotes;
  }

  public get pollingPlaceName(): string {
    return this._haStaticPollingPlace.pollingPlaceName;
  }

  public get pollingPlaceType(): string {
    return this._haStaticPollingPlace.pollingPlaceType;
  }

  public get coordinates(): string {
    return this._haStaticPollingPlace.coordinates;
  }

  public get locationAddress(): string {
    return this._haStaticPollingPlace.locationAddress;
  }

  public get accessibility(): string {
    return this._haStaticPollingPlace.accessibility;
  }

}
